/**
 * Copyright Warner Bros. Entertainment, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property
 * of Warner Bros. Entertainment, Inc. and its suppliers, if any.
 * The intellectual and technical concepts contained herein are
 * proprietary to Warner Bros. Entertainment, Inc. and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in process,
 * and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is
 * unlawful and strictly forbidden unless prior written permission is
 * obtained from Warner Bros. Entertainment, Inc.
 */

import LookupActions from '../lookup-actions';

const CONSTANTS = {
    GET: {
        ERROR: 'language_actions.get.error',
        START: 'language_actions.get.start',
        SUCCESS: 'language_actions.get.success'
    },
    MESSAGES: {
        CREATE_ERROR: 'lookups.language.create.error',
        CREATE_OK: 'lookups.language.create.ok',
        REMOVE_ERROR: 'lookups.language.remove.error',
        REMOVE_OK: 'lookups.language.remove.ok',
        SAVE_ERROR: 'lookups.language.save.error',
        SAVE_OK: 'lookups.language.save.ok',
    },
    REMOVE_OK: 'language_actions.remove',
    SAVE_OK: 'language_actions.save'
};

class LanguageActions extends LookupActions {

    constructor(path, CONSTS) {
        super(path, CONSTS);
    }

}

let actions = new LanguageActions('lookup/language', CONSTANTS);

export {
    actions as LanguageActions,
    CONSTANTS as LanguageConstants
};
